export default function (queue, freq = 3, skew = 2) {
    this.queueData = queue;
    this.freq = freq;
    this.skew = Math.min(freq, skew);
    this.getRange = function () {
        return this.freq + Math.floor(Math.random() * this.skew * 2 - this.skew);
    };
    this.reorderQueue = function () {
        if (this.queueData.length === 1) {
            return this.queueData[0];
        }
        const queue = [];
        const secondary = this.queueData.slice(1).sort(() => Math.random() - 0.5);

        const [main] = this.queueData;

        while (secondary.length) {
            let count = this.getRange();

            while (count > 0) {
                queue.push(main);
                count--;
            }

            queue.push(secondary.pop());
        }

        this.queue = queue;

    };
    this.getNext = function () {
        if (!this.queue.length) {
            this.reorderQueue();
        }
        return this.queue.shift();
    };
    this.reorderQueue();
};
